import { makeDateSeries } from '@local_modules/generic/dates/make-date-series/index.js'
import { activateOptionSelector } from '../../../../modules/option-selector/index.js'

export function showSelectors (changeAction, browserAppAccount) {
  console.log('showSelectors', browserAppAccount)

  const optionSelectorShow = [
    'dates',
    'decimals'
  ]

  const dateseries = makeDateSeries(browserAppAccount.data.firstLedgerDate)
  const currencies = browserAppAccount.data.currencies

  const optionSelectorParams = activateOptionSelector({
    containerId: 'optionSelector',
    show: optionSelectorShow,
    hide: ['currencies'],
    default: 'organisations',
    onChange: changeAction,
    dateseries,
    dateOptions: {
      default: {
        from: 'relative:-2',
        to: 'relative:0'
      }
    },
    customSettings: {
      organisations: mapOrganisations(browserAppAccount),
      orgOptions: {
        allowConso: false,
        allowMultiple: true
        // defaultIndex: 0
      },
      currencies
    }
  })
  return optionSelectorParams
}

function mapOrganisations (browserAppAccount) {
  const accountingsOrganisations = browserAppAccount.data?.entities
  // console.log('accountData', accountData)

  const organisations = accountingsOrganisations?.map(function (accountOrganisation) {
    return accountOrganisation
  })
  organisations.sort((a, b) => a.name.localeCompare(b.name))
  return organisations
}
